export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20editorial%20fashion%20flat%20lay%20with%20vibrant%20sneakers%20designer%20handbags%20sunglasses%20and%20gold%20accessories%20scattered%20across%20a%20textured%20charcoal%20slate%20surface%2C%20dramatic%20side%20lighting%20creating%20bold%20shadows%2C%20luxury%20street%20style%20aesthetic%2C%20high%20contrast%20composition%2C%20modern%20urban%20edge%2C%20deep%20rich%20color%20palette%20with%20crimson%20red%20leather%20black%20matte%20textures%20and%20metallic%20gold%20accents%2C%20no%20text%20or%20visible%20branding%2C%20premium%20product%20photography%20style&width=1600&height=900&seq=sugargoo-hero-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet curated fashion finds collection with sneakers and luxury accessories"
          title="Sugargoo Spreadsheet - Curated Fashion Finds"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900/65 via-foreground-900/35 to-transparent"></div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-5">
                <div className="flex -space-x-2">
                  <div className="w-9 h-9 rounded-full border-2 border-background-50 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20man%20with%20short%20dark%20hair%20and%20confident%20expression%2C%20studio%20lighting%20against%20pure%20white%20backdrop%2C%20modern%20casual%20blazer%20style%2C%20clean%20corporate%20portrait%20photography&width=80&height=80&seq=avatar-1-v2&orientation=squarish"
                      alt="Trusted buyer avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 rounded-full border-2 border-background-50 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20woman%20with%20long%20hair%20and%20warm%20friendly%20smile%2C%20studio%20lighting%20against%20pure%20white%20backdrop%2C%20contemporary%20casual%20style%2C%20clean%20beauty%20portrait%20photography&width=80&height=80&seq=avatar-2-v2&orientation=squarish"
                      alt="Trusted buyer avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 rounded-full border-2 border-background-50 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20man%20with%20glasses%20and%20genuine%20relaxed%20smile%2C%20studio%20lighting%20against%20pure%20white%20backdrop%2C%20smart%20casual%20style%2C%20clean%20corporate%20portrait%20photography&width=80&height=80&seq=avatar-3-v2&orientation=squarish"
                      alt="Trusted buyer avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <span className="text-background-50 text-sm md:text-base font-semibold">
                  Trusted by 10,000+ Shoppers
                </span>
              </div>

              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4">
                <span className="block tracking-tight">SUGARGOO</span>
                <span className="block font-light italic text-3xl md:text-5xl lg:text-6xl">Spreadsheet Directory</span>
              </h1>

              <p className="text-background-200/90 text-sm md:text-base max-w-lg leading-relaxed mb-7">
                Discover the most comprehensive collection of Sugargoo spreadsheet finds — curated sneakers, premium clothing, luxury bags, and hard-to-find accessories, all organized for effortless browsing.
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href="#categories"
                  className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Explore All Finds
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}